<template>
    <div class="c-panel c-panel--border c-panel--expand margin-b-24">
        <h3 class="margin-b-8">Bedankt! Je hebt de opdracht geaccepteerd</h3>
        <div class="fs-small" v-if="request && request.is_tolk_opdracht">
            De aanvrager verwacht jou {{request.begintijd | date}} om {{request.begintijd | time}}
            <template v-if="request.type_aanwezigheid == 'Fysiek'">
                op locatie {{ locatie }}
            </template>
            <template v-else-if="request.type_aanwezigheid == 'Telefonisch'">
                telefonisch. Je wordt gebeld.
            </template>
            <template v-else>
                online op <a :href="url">{{ request.aanwezigheid_url }}</a>
            </template>
        </div>
        <div class="flex">
            <a v-if="request.is_tolk_opdracht" class="c-btn c-btn--secondary c-btn--small c-btn--expanded c-btn--icon margin-b-8 margin-t-24" download="tolk-afspraak.ics" :href="blob">
                <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M8 15c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm8 0c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1Zm2 5H6c-.551 0-1-.449-1-1v-6h14v6c0 .551-.449 1-1 1M6 6h1v1c0 .55.45 1 1 1s1-.45 1-1V6h6v1c0 .55.45 1 1 1s1-.45 1-1V6h1c.551 0 1 .449 1 1v4H5V7c0-.551.449-1 1-1m12-2h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H9V3c0-.55-.45-1-1-1s-1 .45-1 1v1H6C4.346 4 3 5.346 3 7v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3" id="agenda"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#agenda"/></svg>
                <span>Aan agenda toevoegen</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        request: {
            type: Object,
            default: false
        }
    },
    data() {
        return {
            ics: null
        }
    },
    methods: {
        formatDate(date) {
            let datestring = this.$options.filters.datestring(date);
            let timestring = this.$options.filters.time(date);

            return datestring.replace(/[\-\.\:]+/g, '') + 'T' +
                    timestring.replace(/[\-\.\:]+/g, '') + '00';
        }
    },
    computed: {
        locatie() {
            return this.request.adres ? this.request.adres.locatie : this.request.opdrachtgever.adres.locatie;
        },
        url() {
            return (String(this.request.aanwezigheid_url).startsWith('http') ? '' : 'https://') + this.request.aanwezigheid_url;
        },
        blob() {
            var message =
                "BEGIN:VCALENDAR\n" +
                "CALSCALE:GREGORIAN\n" +
                "METHOD:PUBLISH\n" +
                "PRODID:-//SIGV Translation Delivery System//EN\n" +
                "VERSION:2.0\n" +
                "BEGIN:VEVENT\n" +
                "DTSTAMP:" + this.formatDate(new Date().toString()) +
                "\n" +
                "UID:test-1\n" +
                "DTSTART:" + this.formatDate(this.request.begintijd) +
                "\n" +
                "DTEND:" + this.formatDate(this.request.eindtijd)  +
                "\n" +
                "SUMMARY: SIGV Tolkafspraak\n" +
                "LOCATION: " + String(this.locatie).replace("\n", "\\n") + "\n" +
                "DESCRIPTION:" + this.request.type_aanwezigheid + "\\n" +
                this.request.aanwezigheid_url + "\\n" +
                String(this.request.instructies).replace("\n", "\\n") +
                "\n" +
                "END:VEVENT\n" +
                "END:VCALENDAR";

            var data = new File([message], { type: "text/plain" });

            if ( this.ics === null ) {
                window.URL.revokeObjectURL(this.ics);
            }

            this.ics = window.URL.createObjectURL(data);

            return this.ics;
        }
    }
}
</script>
